import { ICountryState } from '@common-types';

export const USA_STATES: ICountryState[] = [
  { name: 'Alabama', postalCode: 'AL' },
  { name: 'Alaska', postalCode: 'AK' },
  { name: 'Arizona', postalCode: 'AZ' },
  { name: 'Arkansas', postalCode: 'AR' },
  { name: 'California', postalCode: 'CA' },
  { name: 'Colorado', postalCode: 'CO' },
  { name: 'Connecticut', postalCode: 'CT' },
  { name: 'Delaware', postalCode: 'DE' },
  { name: 'District of Columbia', postalCode: 'DC' },
  { name: 'Florida', postalCode: 'FL' },
  { name: 'Georgia', postalCode: 'GA' },
  { name: 'Hawaii', postalCode: 'HI' },
  { name: 'Idaho', postalCode: 'ID' },
  { name: 'Illinois', postalCode: 'IL' },
  { name: 'Indiana', postalCode: 'IN' },
  { name: 'Iowa', postalCode: 'IA' },
  { name: 'Kansas', postalCode: 'KS' },
  { name: 'Kentucky', postalCode: 'KY' },
  { name: 'Louisiana', postalCode: 'LA' },
  { name: 'Maine', postalCode: 'ME' },
  { name: 'Maryland', postalCode: 'MD' },
  { name: 'Massachusetts', postalCode: 'MA' },
  { name: 'Michigan', postalCode: 'MI' },
  { name: 'Minnesota', postalCode: 'MN' },
  { name: 'Mississippi', postalCode: 'MS' },
  { name: 'Missouri', postalCode: 'MO' },
  { name: 'Montana', postalCode: 'MT' },
  { name: 'Nebraska', postalCode: 'NE' },
  { name: 'Nevada', postalCode: 'NV' },
  { name: 'New Hampshire', postalCode: 'NH' },
  { name: 'New Jersey', postalCode: 'NJ' },
  { name: 'New Mexico', postalCode: 'NM' },
  { name: 'New York', postalCode: 'NY' },
  { name: 'North Carolina', postalCode: 'NC' },
  { name: 'North Dakota', postalCode: 'ND' },
  { name: 'Ohio', postalCode: 'OH' },
  { name: 'Oklahoma', postalCode: 'OK' },
  { name: 'Oregon', postalCode: 'OR' },
  { name: 'Pennsylvania', postalCode: 'PA' },
  { name: 'Rhode Island', postalCode: 'RI' },
  { name: 'South Carolina', postalCode: 'SC' },
  { name: 'South Dakota', postalCode: 'SD' },
  { name: 'Tennessee', postalCode: 'TN' },
  { name: 'Texas', postalCode: 'TX' },
  { name: 'Utah', postalCode: 'UT' },
  { name: 'Vermont', postalCode: 'VT' },
  { name: 'Virginia', postalCode: 'VA' },
  { name: 'Washington', postalCode: 'WA' },
  { name: 'West Virginia', postalCode: 'WV' },
  { name: 'Wisconsin', postalCode: 'WI' },
  { name: 'Wyoming', postalCode: 'WY' },
  { name: 'American Samoa', postalCode: 'AS' },
  { name: 'Guam', postalCode: 'GU' },
  { name: 'Marshall Islands', postalCode: 'MH' },
  { name: 'Micronesia', postalCode: 'FM' },
  { name: 'Northern Mariana Islands', postalCode: 'MP' },
  { name: 'Palau', postalCode: 'PW' },
  { name: 'Puerto Rico', postalCode: 'PR' },
  { name: 'Virgin Islands', postalCode: 'VI' },
];

const USA_STATE_TRANSLATIONS: { [key: string]: string } = {
  'Alabama': 'Alabama',
  'Alaska': 'Alaska',
  'Arizona': 'Arizona',
  'Arkansas': 'Arkansas',
  'California': 'California',
  'Colorado': 'Colorado',
  'Connecticut': 'Connecticut',
  'Delaware': 'Delaware',
  'District of Columbia': 'Distrito de Columbia',
  'Florida': 'Florida',
  'Georgia': 'Georgia',
  'Hawaii': 'Hawái',
  'Idaho': 'Idaho',
  'Illinois': 'Illinois',
  'Indiana': 'Indiana',
  'Iowa': 'Iowa',
  'Kansas': 'Kansas',
  'Kentucky': 'Kentucky',
  'Louisiana': 'Luisiana',
  'Maine': 'Maine',
  'Maryland': 'Maryland',
  'Massachusetts': 'Massachusetts',
  'Michigan': 'Míchigan',
  'Minnesota': 'Minnesota',
  'Mississippi': 'Misisipi',
  'Missouri': 'Misuri',
  'Montana': 'Montana',
  'Nebraska': 'Nebraska',
  'Nevada': 'Nevada',
  'New Hampshire': 'Nuevo Hampshire',
  'New Jersey': 'Nueva Jersey',
  'New Mexico': 'Nuevo México',
  'New York': 'Nueva York',
  'North Carolina': 'Carolina del Norte',
  'North Dakota': 'Dakota del Norte',
  'Ohio': 'Ohio',
  'Oklahoma': 'Oklahoma',
  'Oregon': 'Oregón',
  'Pennsylvania': 'Pensilvania',
  'Rhode Island': 'Rhode Island',
  'South Carolina': 'Carolina del Sur',
  'South Dakota': 'Dakota del Sur',
  'Tennessee': 'Tennessee',
  'Texas': 'Texas',
  'Utah': 'Utah',
  'Vermont': 'Vermont',
  'Virginia': 'Virginia',
  'Washington': 'Washington',
  'West Virginia': 'Virginia Occidental',
  'Wisconsin': 'Wisconsin',
  'Wyoming': 'Wyoming',
  'American Samoa': 'Samoa Americana',
  'Guam': 'Guam',
  'Marshall Islands': 'Islas Marshall',
  'Micronesia': 'Micronesia',
  'Northern Mariana Islands': 'Islas Marianas del Norte',
  'Palau': 'Palaos',
  'Puerto Rico': 'Puerto Rico',
  'Virgin Islands': 'Islas Vírgenes',
};

export const USA_STATES_ES = USA_STATES.map(s => ({
  ...s,
  name: USA_STATE_TRANSLATIONS[s.name] || s.name,
}));

export const CANADA_STATES: ICountryState[] = [
  { name: 'Newfoundland and Labrador', postalCode: 'NL' },
  { name: 'Prince Edward Island', postalCode: 'PE' },
  { name: 'Nova Scotia', postalCode: 'NS' },
  { name: 'New Brunswick', postalCode: 'NB' },
  { name: 'Quebec', postalCode: 'QC' },
  { name: 'Ontario', postalCode: 'ON' },
  { name: 'Manitoba', postalCode: 'MB' },
  { name: 'Saskatchewan', postalCode: 'SK' },
  { name: 'Alberta', postalCode: 'AB' },
  { name: 'British Columbia', postalCode: 'BC' },
  { name: 'Yukon', postalCode: 'YT' },
  { name: 'Northwest Territories', postalCode: 'NT' },
  { name: 'Nunavut', postalCode: 'NU' },
];

const CANADA_STATE_TRANSLATIONS: { [key: string]: string } = {
  'Newfoundland and Labrador': 'Terranova y Labrador',
  'Prince Edward Island': 'Isla del Príncipe Eduardo',
  'Nova Scotia': 'Nueva Escocia',
  'New Brunswick': 'Nuevo Brunswick',
  'Quebec': 'Quebec',
  'Ontario': 'Ontario',
  'Manitoba': 'Manitoba',
  'Saskatchewan': 'Saskatchewan',
  'Alberta': 'Alberta',
  'British Columbia': 'Columbia Británica',
  'Yukon': 'Yukón',
  'Northwest Territories': 'Territorios del Noroeste',
  'Nunavut': 'Nunavut',
};

export const CANADA_STATES_ES = CANADA_STATES.map(c => ({
  ...c,
  name: CANADA_STATE_TRANSLATIONS[c.name] || c.name,
}));